import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router'
import { useDispatch } from 'react-redux'

import { If } from '../../../../deprecated/Conditionals'
import AppHeader from '../../../../App/Layout/AppHeader'
import NewHomeWizard from '../../../../Components/homeowners/NewHomeWizard'
import HomeownerReportTeaser from '../../../../Components/shared/Teasers/HomeownerReportTeaser'
import HomeownerReportVideoSection from '../../../../Components/homeowners/HomeownerReportVideoSection'

// Actions
import { setActiveTab } from '../../../../actions/navigation'

// Utils
import { TAB_NAMES } from '../../../../mappings/navigation'

const NewHome = ({ hasHomes, notFound }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setActiveTab(TAB_NAMES.ADD_HOME))
  }, [dispatch])

  return (
    <>
      <If condition={notFound}>
        <Redirect to='/not-found' />
      </If>
      <AppHeader enableAgentDropdown />
      <NewHomeWizard />
      <If condition={!hasHomes}>
        <HomeownerReportTeaser />
        <HomeownerReportVideoSection />
      </If>
    </>
  )
}

NewHome.propTypes = {
  hasHomes: PropTypes.number,
  notFound: PropTypes.bool,
}

export default NewHome
